// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1hC2H","content":"RecentSearches_content__3VtD1"};